import { JustLogo } from '@/components/JustLogo';
import { BRAND_HTML_META } from './meta';
import type { BrandConfig } from './types';

// Brand default - identidade JUST atual. Valores copiados verbatim de
// apps/web/src/styles/tokens.css (bloco BRAND PALETTE) para que o build
// default (VITE_BRAND nao setado) continue pixel-igual ao que ja existe.
export const justBrand: BrandConfig = {
  id: 'just',
  ...BRAND_HTML_META.just,
  legalFooter: '(c) 2026 JUST Tecnologia Financeira - Tecnologia de Meios de Pagamento Ltda.',
  palette: {
    navy: {
      '50': '#e9ecf0',
      '100': '#c5cad4',
      '200': '#97a0b4',
      '300': '#6a7694',
      '400': '#4a5f8e',
      '500': '#334470',
      '600': '#263450',
      '700': '#1e2848',
      '800': '#161d3d',
      '900': '#0f112b',
    },
    accent: {
      '50': '#fdeeec',
      '100': '#fbd5d1',
      '200': '#f8ada5',
      '300': '#f69689',
      '400': '#f67469',
      '500': '#f45546',
      '600': '#e03d2e',
      '700': '#c7301f',
      '800': '#a8281a',
      '900': '#881f14',
    },
  },
  Logo: JustLogo,
  pdf: {
    navyRgb: [15, 17, 43],
    accentRgb: [244, 85, 70],
  },
};
